import { getCurrentLanguage } from 'owa-localize';

export function isLocaleAvailable(): boolean {
    return AvailableDiagnosticsLocales.includes(getCurrentLanguage());
}

const AvailableDiagnosticsLocales = [
    'af',
    'am',
    'ar',
    'as-IN',
    'az-Latn-AZ',
    'bg',
    'bn-IN',
    'bs-Latn-BA',
    'ca',
    'ca-Es-VALENCIA',
    'cs',
    'cy',
    'da',
    'de',
    'el',
    'en-GB',
    'en-US',
    'es',
    'es-MX',
    'et',
    'eu',
    'fa',
    'fi',
    'fil',
    'fr',
    'fr-CA',
    'ga-IE',
    'gd-gb',
    'gl',
    'gu',
    'he',
    'hi',
    'hr',
    'hu',
    'hy',
    'id',
    'is',
    'it',
    'ja',
    'ka',
    'kk',
    'km-KH',
    'kn',
    'ko',
    'kok',
    'lb-LU',
    'lo-LA',
    'lt',
    'lv',
    'mi-NZ',
    'mk',
    'ml',
    'mr',
    'ms',
    'mt-MT',
    'ne-NP',
    'nl',
    'nn-NO',
    'no',
    'or',
    'pa-IN',
    'pl',
    'pt',
    'pt-PT',
    'quz-PE',
    'ro',
    'ru',
    'sk',
    'sl',
    'sq',
    'sr',
    'sr-Cyrl',
    'sr-Cyrl-BA',
    'sv',
    'ta',
    'te',
    'th',
    'tr',
    'tt',
    'ug-CN',
    'uk',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
];
